import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class HttpErrorService {
	protected errorSubject = new Subject<HttpErrorResponse>();

	constructor() {
	}

	get error$(): Observable<HttpErrorResponse> {
		return this.errorSubject
	}

	emitError(error: HttpErrorResponse) {
		this.errorSubject.next(error)
	}
}